<template>

    <q-card-section class="q-pa-sm">
      <div class="q-px-sm">
        <span class="text-bold">Load board overview {{loadBoardForOrder?.listingId??''}}</span>
        <span class="small float-right "  v-if="loadBoardForOrder?.refreshedOn??false">
          {{loadBoardForOrder.refreshedOn | localTime}}
        </span>
      </div>

      <div>
        <div
            v-if="(loadBoardForOrder?.httpCode??-1) === 0"
            class="row"
        >
          <div class="col-12 text-center">
            No load board connected
          </div>
        </div>

        <div
            v-if="((loadBoardForOrder?.httpCode??-1) >= 400) && ((loadBoardForOrder?.httpCode??-1) < 500)"
            class="row"
        >
            <div class="col-12 text-negative text-center">
              {{loadBoardForOrder.listingId}} was deleted remotely, but is still connected to the order
            </div>
        </div>

        <div
            class="row"
            v-if="((loadBoardForOrder?.httpCode??-1) >= 200) && ((loadBoardForOrder?.httpCode??-1) < 400)"
        >
              <div v-if="loadBoardForOrder.createdOn" class="col-12 col-sm-6 col-lg-3">


                <span class="text-bold q-mr-sm">Created</span>

                {{
                    loadBoardForOrder.createdOn | localTime
                  }}


              </div>

              <div v-if="loadBoardForOrder.expirationDate" class="col-12 col-sm-6 col-lg-3">
                <span class="text-bold q-mr-sm">Expires</span>
                {{
                  loadBoardForOrder.expirationDate | localTime
                }}
              </div>

              <div v-if="loadBoardForOrder.listingStatus" class="col-12 col-sm-6 col-lg-3">

                <span class="text-bold q-mr-sm">Status</span>
                {{ loadBoardForOrder.listingStatus }}
              </div>

              <div v-if="loadBoardForOrder.totalDistanceInMiles" class="col-12 col-sm-6 col-lg-3">
                <span class="text-bold q-mr-sm">miles</span>
                {{ loadBoardForOrder.totalDistanceInMiles }}
              </div>

        </div>
      </div>
    </q-card-section>

</template>

<script>
import graphql from '@client/graphql';

export default {
  name: 'AppLoadBoardOverview',
  props: ['orderId'],
  apollo: {
    loadBoardForOrder: {
      query: graphql.queries.getLoadBoardForOrder,
      variables() {
        return { orderId: parseInt(this.orderId.toString()) };
      },
      watchLoading(isLoading) {
        this.loading = isLoading;
      }
    }
  },
  data() {
    return {
      loading: false
    };
  },
  methods: {

    async refreshLoadBoardOverview() {
      this.$apollo.queries.loadBoardForOrder.refetch();
    }
  }
};
</script>

